
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.438 14.215c.24.068.474-.069.55-.332l2.857-9.99c.072-.264-.048-.508-.287-.581-.239-.069-.473.068-.55.332l-2.852 9.99c-.072.264.043.508.282.58v.001zm4.757-1.772l3.598-3.316a.48.48 0 000-.727l-3.598-3.316c-.197-.19-.47-.185-.637.005-.167.19-.139.464.053.645l3.282 3.027-3.282 3.032c-.192.18-.22.454-.053.645.168.19.44.19.637.005zm-6.393.004c.2.186.469.181.636-.01.168-.19.144-.458-.048-.639L2.108 8.766 5.39 5.734c.192-.181.216-.45.048-.645-.167-.19-.435-.19-.636-.005L1.204 8.4a.487.487 0 000 .727l3.598 3.32z","fill":"#000C1F"}})])
          )
        }
      }
    